import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed';

const Targeting = {
  Helmet: lazy(() => import('./components/Helmet')),
  DefaultValues: lazy(() => import('./DefaultValues')),
  ConfigsTargeting: lazy(() => import('./KeywordsTargeting')),
  KeywordsTargeting: lazy(() => import('./KeywordsTargeting/KeywordsTargetingForm')),
  SegmentsTargeting: lazy(() => import('./SegmentsTargeting')),
  VisitorSegments: lazyNamed(() => import('./VisitorSegments'), 'VisitorSegments'),
  NewSegmentsTargeting: lazy(() => import('./SegmentsTargeting/UpdateCreateSegmentTargeting/NewSegmentsTargeting')),
  Layout: lazy(() => import('./components/Layout')),
};

export default Targeting;
